"use client";

import { Building2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useTenantContext } from "./TenantContextProvider";

export function TenantSwitcher() {
  const tenantState = useTenantContext();

  if (tenantState.status !== "ready") {
    return <Badge variant="info">Tenant loading</Badge>;
  }

  if (tenantState.memberships.length <= 1) {
    return (
      <div className="flex h-9 items-center gap-2 rounded-md border border-border bg-card px-3 text-sm">
        <Building2 size={14} />
        <span>{tenantState.tenant.tenantName}</span>
      </div>
    );
  }

  return (
    <label className="flex h-9 items-center gap-2 rounded-md border border-border bg-card px-3 text-sm">
      <Building2 size={14} />
      <span className="sr-only">Tenant</span>
      <select
        className="bg-transparent text-sm outline-none"
        value={tenantState.tenantId}
        onChange={(event) => tenantState.selectTenant(event.target.value)}
      >
        {tenantState.memberships.map((membership) => (
          <option key={membership.tenantId} value={membership.tenantId}>
            {membership.tenantName}
          </option>
        ))}
      </select>
    </label>
  );
}
